module.exports = __webpack_public_path__ + "static/media/qingming3Bg.ed0d1cc7.jpg";